<template>
  <div class="tab_content tab__inventory">
    <div class="inventory__note vx-row items-center mx-2">
      <h3 class="mr-2">Inventory</h3>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 ml-auto">
      <inventory
        ref="inventory"
        @add-inventory="addInventory(i)"
        @remove-inventory="removeInventory(i)"
        @inventory-changed="val => inventoryChanged(i, val)"
        :title="`Inventory-${i + 1}`"
        :key="i"
        v-for="(inventory, i) in form.inventories"
        :inventory.sync="form.inventories[i]"
        @qty-changed="val => qtyChangeHandler(i, val)"
        class="mt-4"
      />
    </div>
  </div>
</template>

<script>
import { weightTypes, weightMixins } from '@/utils/weightType'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import Inventory from '@/views/products/components/Inventory.vue'
import { mapActions } from 'vuex'

export default {
  name: 'InventoryTab',
  components: {
    Select2,
    Inventory
  },
  props: {
    form: {}
  },
  data() {
    const emptyIventory = {
      inventoryId: null,
      weightType: null,
      inventory_quantity: 0,
      inventory_avail_quantity: 0
    }
    return {
      emptyIventory,
      weightTypes
    }
  },
  mixins: [weightMixins],
  methods: {
    ...mapActions('inventory', ['getIngredientOption']),
    ...mapActions('product', ['removeInventoryById']),
    addInventory(i) {
      this.form.inventories.splice(i + 1, 0, this.emptyIventory)
      this.$emit('update:form', {
        ...this.form
      })
    },
    async removeInventory(i) {
      // if (this.form.inventories[i] && this.form.inventories[i].id) {
      //   try {
      //     const { message } = await this.removeInventoryById(this.form.inventories[i].id)
      //     this.$vs.notify({
      //       title: 'Success',
      //       text: message,
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'success'
      //     })
      //   } catch ({ message }) {
      //     this.$vs.notify({
      //       title: 'Error',
      //       text: message,
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'danger'
      //     })
      //   }
      // }
      if (this.form.inventories.length !== 1) {
        this.form.inventories.splice(i, 1)
      } else {
        this.form.inventories[0] = this.emptyIventory
      }
      this.$emit('update:form', {
        ...this.form
      })
    },
    inventoryChanged(i, val) {
      this.form.inventories[i] = val
      this.$emit('update:form', {
        ...this.form,
        inventories: this.form.inventories
      })
      this.form.inventories.reduce((coll, inv) => {
        if (coll.includes(inv.inventoryId)) {
          this.$vs.notify({
            title: 'Error',
            text: 'Inventory cannot be selected twice!.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.form.inventories[i].inventoryId = null
          this.form.inventories[i].weightType = null
          this.form.inventories[i].inventory_quantity = 0
        } else {
          coll.push(inv.inventoryId)
        }
        return coll
      }, [])
    },
    qtyChangeHandler(i, val) {
      this.form.inventories[i] = {
        ...this.form.inventories[i],
        inventory_quantity: this.mathRound(val, 3)
      }
      this.$emit('update:form', {
        ...this.form,
        inventories: this.form.inventories
      })
    }
  },

  async mounted() {
    await this.getIngredientOption()
  }
}
</script>
